import { RadioButtons, Typography } from '@adac-mp/components';
import { IFuelTypes, OfferContext, VignetteContext } from '@adac-mp/shared';
import React, { useContext, useEffect, useState } from 'react';

interface IVignettenFuelType {
	className?: string;
	defaultFuelId?: number;
	defaultFuelIds?: number[];
	indented?: boolean;
	withAllFuelsOption?: boolean;
	onFuelChanged: (fuelId: number) => void;
}

export const VignetteFuelType = ({
	className = '',
	defaultFuelId = undefined,
	defaultFuelIds = [6, 7],
	indented,
	withAllFuelsOption,
	onFuelChanged,
}: IVignettenFuelType) => {
	const { selectedProducts } = useContext(VignetteContext);
	const { allFuels } = useContext(OfferContext);
	const [fuelId, setFuelId] = useState<number | undefined>(selectedProducts[0]?.fuelTypeId ?? defaultFuelId);
	const [availableFuels, setAvailableFuels] = useState<IFuelTypes[] | undefined>(undefined);

	useEffect(() => {
		const fetchFuels = async () => {
			if (allFuels) {
				const filteredFuels = allFuels.filter(({ id }) => defaultFuelIds.includes(id));
				if (withAllFuelsOption) {
					filteredFuels.push({ id: -1, name: 'Benzin oder Diesel' });
				}
				setAvailableFuels(filteredFuels.sort((a, b) => a.id - b.id));
			}
		};
		fetchFuels();
	}, [allFuels]);

	const renderOptionLabel = (fuelName: string) => (
		<div className="flex justify-between">
			<div>
				<Typography variant="title" size="lg">
					{fuelName}
				</Typography>
			</div>
		</div>
	);

	return (
		<div className={className}>
			<div className={`bg-white rounded`}>
				{availableFuels && (
					<RadioButtons
						data-cy="fuel"
						idAlias="fuel"
						className={`${
							indented && 'px-4'
						} py-2 border-b border-l-0 border-t-0 border-r-0 border-solid border-b-gray-600 last:border-b-0 last:rounded-b md:py-3`}
						labelClassName="w-full"
						value={String(fuelId)}
						setValue={(value) => {
							const selectedFuelId = Number(value);
							setFuelId(selectedFuelId);
							onFuelChanged(selectedFuelId);
						}}
						size="md"
						options={availableFuels.map(({ id, name }) => ({
							id: String(id),
							label: renderOptionLabel(name),
							title: name,
						}))}
					/>
				)}
			</div>
		</div>
	);
};
